import { MESSAGING, FIREBASE } from 'core/datasets/action';
import { all, fork, takeEvery, takeLatest } from 'redux-saga/effects';
import { channelSelectedAndMessagesSubscribed } from './workers/channelSelected';
import { channelViewed } from './workers/channelViewed';
import { fetchChannelDataByKey } from './workers/fetchChannelDataByKey';
import { subscribeToChannelMapMetadata } from './workers/subscribeToChannelMapMetadata';
import { updateChannelsMapMetadata } from './workers/updateChannelsMapMetadata';
import { sendNewMessage } from './workers/sendNewMessage';
import { getChannelsMap } from './workers/getChannelsMap';
import { parseChannelsMap } from './workers/parseChannelsMap';

export function* watchChannelMapSet(): Generator {
    yield takeEvery(MESSAGING.SET_CHANNELS_MAP, subscribeToChannelMapMetadata);
}

export function* watchUpdateChannelsMap(): Generator {
    yield takeLatest(FIREBASE.SET_FIREBASE_USER, updateChannelsMapMetadata);
}

export function* watchNewChannelKeys(): Generator {
    yield takeEvery(MESSAGING.ADD_CHANNEL_KEY, fetchChannelDataByKey);
}

export function* watchSendNewMessage(): Generator {
    yield takeEvery(MESSAGING.SEND_NEW_MESSAGE, sendNewMessage);
}

export function* watchChannelSelected(): Generator {
    yield takeEvery(MESSAGING.SELECT_CHANNEL, channelSelectedAndMessagesSubscribed);
}

export function* watchChannelViewed(): Generator {
    yield takeEvery(MESSAGING.CHANNEL_VIEWED, channelViewed);
}

export function* watchGetChannelsMap(): Generator {
    yield takeLatest(MESSAGING.GET_CHANNELS_MAP, getChannelsMap);
}

export function* watchFetchedChannelMapMetadata(): Generator {
    yield takeLatest(MESSAGING.FETCHED_NEW_CHANNELS_MAP, parseChannelsMap);
}

export function* messagingWatchers(): Generator {
    yield all([
        fork(watchChannelMapSet),
        fork(watchSendNewMessage),
        fork(watchNewChannelKeys),
        fork(watchChannelSelected),
        fork(watchChannelViewed),
        fork(watchUpdateChannelsMap),
        fork(watchGetChannelsMap),
        fork(watchFetchedChannelMapMetadata),
    ]);
}
